module.exports = __webpack_public_path__ + "img/ResourcesBG.cb26eb9d.jpg";